<template>
  <div class="help">
    <div>
      <p class="title">1.怎样参与竞拍？</p>
      <p>进入竞拍首页后，点击您想要竞拍的产品，在竞拍时间内，您可以出价参与竞拍，最终竞拍结果以结束竞拍时出价最高者获得。出价最高者在竞拍结束补缴尾款后，方可领取拍得的产品。</p>
      <p class="title">2.为什么竞拍到了时间还没有结束？</p>
      <p>如果竞拍结束前10分钟内有用户出价，结束时间将顺延10分钟。直至强制结束时间系统自动强制结束为止。</p>
      <p class="title">3.我可以使用什么作为保证金？</p>
      <p>每款产品的竞拍保证金不同，保证金可能为账号内的会员天数、联众币或游乐豆，竞拍产品页面内会有相应说明。</p>
      <p>举例：某产品保证金100联众币。</p>
      <p>则代表您的产品需要使用联众币进行竞拍，在出价时，您的账号内需要有不少于100联众币。</p>
      <p class="title">4.怎么出价？</p>
      <p>竞拍开始后，您可以进入想要参与的竞拍活动页内，出价栏内默认显示符合当前竞拍条件的最低出价，您可以直接点击下方“出价”直接出价，也可以通过点击价格栏右侧+、-号调整出价（您的出价不能低于目前的最高出价），也可以直接在出价栏内填写您心目中的出价数额，点击红色出价按钮即可。出价后，您的保证金将作为竞拍定金被冻结。</p>
      <p class="title">5.竞拍记录里我的出价信息被划掉了是什么意思？</p>
      <p>竞拍中，如果有人出价高于您，您之前的出价作废，被冻结的保证金将在10分钟内退还。</p>
      <p class="title">6.竞拍失败我的保证金多久退回？</p>
      <p>如果其他用户的出价比您高，您的保证金将在10分钟内退回至您的联众账号，您可以在“我的拍卖”中查看出价及退款记录。如果存在异常，请通过页面下方“在线提问”描述您遇到的问题，客服人员将为您核实处理。</p>
      <p class="title">7.页面里最高出价是我，怎么领取我拍到的ID？</p>
      <p>请您在竞拍成功之后，进入“补缴尾款”页面缴纳补款金额。补款成功后，可进入“我的领取”页面领取您的ID。</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "AucHelp",
  data() {
    return {
      //访问前缀，用于区分环境，访问api时使用
      service_url: process.env.VUE_APP_SERVICE_URL
        ? process.env.VUE_APP_SERVICE_URL
        : "",
      notices0: []
    };
  },
  methods: {
    //公告列表
    init_Notices_0() {
      this.getRequest(this.service_url + "/aucNotice/notices/0").then(resp => {
        if (resp) {
          this.notices0 = resp.data;
        }
      });
    }
  },
  created() {
    //组件加载调用初始化
    this.init_Notices_0();
  },
  components: {}
};
</script>
<style>
	.help {
		width: 925px;
		overflow: hidden;
		margin: 0 auto;
	}
	.help div {
		padding-bottom: 20px;
		font-size: 14px;
		line-height: 30px;
		color: #333;
		padding: 15px;
	}
	.help p {
		padding-bottom: 20px;
		font-size: 14px;
		line-height: 30px;
		color: #333;
	}
	.title {
		font-weight: 800 !important;
		font-size: 16px !important;
	}
</style>